exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "login-feature {\n  display: block; }\n  login-feature .logincontainer {\n    position: relative;\n    border: 1px solid #efefef;\n    padding: 20px 20px 80px 20px; }\n    login-feature .logincontainer default-input {\n      max-width: 100%; }\n    login-feature .logincontainer .resetpw {\n      margin-top: 1rem; }\n    login-feature .logincontainer .errorMessage {\n      color: #e97272;\n      margin: 1rem 0; }\n", ""]);

// exports
